




















import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { Result } from '../../modules/class/RegisterResponseInfo'
import RegisteredUserInfo from '../../modules/class/RegisteredUserInfo'
import Item from '../../modules/class/Item'
import {
  membershipState,
  PageStepName
} from '../../store/modules/MembershipState'
import ChangeMembershipInput from '../../components/Membership/ChangeMembership/ChangeMembershipInput.vue'
import ChangeMembershipConfirm from '../../components/Membership/ChangeMembership/ChangeMembershipConfirm.vue'
import ChangeMembershipComplete from '../../components/Membership/ChangeMembership/ChangeMembershipComplete.vue'
import PathUtil from '../../modules/util/PathUtil'
import camelcaseKeys from 'camelcase-keys'

const JSON_PATH_CATEGORY = PathUtil.makePath(
  '/json/product_category/product_category_list.json'
)
const JSON_PATH_FIELD = PathUtil.makePath(
  '/json/industry_category/industry_category_list.json'
)

@Component({
  components: {
    ChangeMembershipInput,
    ChangeMembershipConfirm,
    ChangeMembershipComplete
  }
})
export default class ChangeMembership extends Vue {
  private readonly vueid = 'vue_change_membership'

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private result: Result = 'success'
  private productCategory: Item[] = []
  private field: Item[] = []
  private country: Item[] = []
  private userInfo: RegisteredUserInfo = {
    result: false,
    email: '',
    firstname: '',
    lastname: '',
    password: '',
    organization: '',
    jobRoles: '',
    phone: '',
    mobilePhone: '',
    countryRegion: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    department: '',
    industry: '',
    emailSubscription: false,
    productCategory: [],
    field: [],
    updateDttm: ''
  }

  // -------------------------------------------------------------------------------------------------------------------
  // getter
  get currentChangeMembershipStep(): PageStepName {
    return membershipState.currentChangeMembershipStep
  }

  get isLogin(): boolean {
    return membershipState.isLogin
  }

  // -------------------------------------------------------------------------------------------------------------------
  // hooks
  private async created() {
    membershipState.addCurrentChangeMembershipStep('input')
  }

  private async mounted() {
    if (document.getElementById(this.vueid) !== null) {
      this.fetchCategory()
      this.fetchField()
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods
  /**
   * 登録されている製品カテゴリ情報を取得する。
   */
  private async fetchCategory() {
    this.getJson(JSON_PATH_CATEGORY, 'category')
  }

  /**
   * 登録されている分野情報を取得する。
   */
  private async fetchField() {
    this.getJson(JSON_PATH_FIELD, 'field')
  }

  /**
   * JSON取得共通処理。
   */
  private async getJson(path: string, type: string) {
    const res = await axios.get(path)
    if (res === undefined || res.status !== 200) {
      return
    }
    const result = camelcaseKeys(res.data, { deep: true })
    if (type === 'category') {
      this.productCategory = result.map(
        (d: { categoryId: number; name: string }) =>
          new Item(String(d.categoryId), d.name)
      )
    } else if (type === 'field') {
      this.field = result.map(
        (d: { categoryId: number; name: string }) =>
          new Item(String(d.categoryId), d.name)
      )
    }
  }
}
